const getRuntimeEnv = () => (
  typeof window !== 'undefined'
  && window.__ENV__
  && typeof window.__ENV__ === 'object'
    ? window.__ENV__
    : {}
);

export const resolvePublicEnv = (name, buildTimeValue, fallback = '') => {
  const runtimeValue = getRuntimeEnv()[name];

  if (typeof runtimeValue === 'string' && runtimeValue.trim()) {
    return runtimeValue.trim();
  }

  if (typeof buildTimeValue === 'string' && buildTimeValue.trim()) {
    return buildTimeValue.trim();
  }

  return fallback;
};
